import React from 'react'
import { ReactComponent } from './accounting-bills.svg'
import { MergeReactElementProps } from '../types'

interface CreditCardProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', CreditCardProps>

export const CreditCard = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill="none" ref={ref} {...props} />
  }
)
